import { useState } from "react";
import { ChevronRight } from "lucide-react";

const ORDER = ["mini-break", "premium", "ultra", "elite"];
const LABEL = { "mini-break": "Mini-Break", premium: "Premium", ultra: "Ultra", elite: "Elite", standalone: "Standalone", guide: "One-off guides" };

export const byTier = (kits) => {
  const map = {};
  kits.forEach((k) => { (map[k.tier || "other"] = map[k.tier || "other"] || []).push(k); });
  return Object.keys(map).sort((a, b) => (ORDER.indexOf(a) + 1 || 99) - (ORDER.indexOf(b) + 1 || 99)).map((t) => ({ tier: t, kits: map[t] }));
};

export const TierGroup = ({ gid, tier, kits, render }) => {
  const [open, setOpen] = useState(true);
  const live = kits.filter((k) => k.product?.published).length;
  return (
    <div data-testid={`tier-group-${gid}-${tier}`} className="border-t border-stone-100">
      <button data-testid={`tier-toggle-${gid}-${tier}`} onClick={() => setOpen(!open)} aria-expanded={open}
        className="w-full flex items-center gap-2 px-5 py-2.5 text-left hover:bg-stone-50 transition-colors">
        <ChevronRight size={15} className={`text-stone-500 transition-transform duration-200 ${open ? "rotate-90" : ""}`} />
        <span className="text-sm font-semibold text-[#2B2A26]">{LABEL[tier] || tier}</span>
        <span data-testid={`tier-count-${gid}-${tier}`} className="text-xs font-mono-ui text-stone-500">{kits.length} · {live} live</span>
      </button>
      {open && <ul data-testid={`tier-list-${gid}-${tier}`}>{kits.map(render)}</ul>}
    </div>
  );
};
